import { configureStore } from '@reduxjs/toolkit';
import employer from './employerSlice';

export const store = configureStore({
  reducer: { employer },
});